import { ErrorModalProvider } from '@g2-shared/common';
import {
  MotionLazyContainer,
  NotistackProvider,
  ProgressBarStyle,
  ScrollToTop,
  ThemeSettings,
} from '@g2-shared/components';
import WuErrorFallback from '@layout/components/WuErrorFallback';
import '@locales/i18n';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Router } from '@routing/Router';
import ThemeProvider from '@theme/index';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from 'react-query';
import { GlobalDIContextProvider } from './context/GlobalDIContext';
import countries from 'i18n-iso-countries';
import * as Sentry from '@sentry/react';

// Import locales directly
import enLocale from 'i18n-iso-countries/langs/en.json';
import bsLocale from 'i18n-iso-countries/langs/bs.json';

countries.registerLocale(enLocale);
countries.registerLocale(bsLocale);

const helmetContext = {};
const queryClient = new QueryClient();

export const App: React.FC = () => (
  <GlobalDIContextProvider>
    <ErrorBoundary
      FallbackComponent={WuErrorFallback}
      onError={(error) => Sentry.captureException(error)}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <QueryClientProvider client={queryClient}>
          <HelmetProvider context={helmetContext}>
            <MotionLazyContainer>
              <ThemeSettings withoutDrawer>
                <ThemeProvider>
                  <ErrorModalProvider>
                    <NotistackProvider>
                      <ProgressBarStyle />
                      <ScrollToTop />
                      <Router />
                    </NotistackProvider>
                  </ErrorModalProvider>
                </ThemeProvider>
              </ThemeSettings>
            </MotionLazyContainer>
          </HelmetProvider>
        </QueryClientProvider>
      </LocalizationProvider>
    </ErrorBoundary>
  </GlobalDIContextProvider>
);
